import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import './styles/vuetify.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#DEB817', // #b58837
    accent: '#212121'
  }
})
